import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Layout from '../home/theme/Layout';

const NotFound = ({ backUrl = '/' }) => {
  return (
    <Layout title="Página no encontrada">
      <div className="container py-5 py-lg-5">
        <div className="row justify-content-center text-center">
          <div className="col-lg-6">

            {/* Ícono */}
            <div className="mb-4">
              <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '64px' }}></i>
            </div>

            {/* Título */}
            <h1 className="h3 fw-bold mb-2">Página no encontrada</h1>

            {/* Subtítulo */}
            <p className="text-muted mb-4">
              Lo sentimos, la página que estás buscando no existe, fue movida o nunca estuvo disponible.
            </p>

            {/* Botón volver */}
            <Button
              as={Link}
              to={backUrl}
              variant="primary"
              className="px-4 py-2"
            >
              <i className="fas fa-arrow-left me-2"></i>
              Regresar
            </Button>

          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
